(function () {
    $(document).ready(function () {
        const titleSelector = '.teaser__title';
        const loaSelector = '.teaser .loa';
        if ($(titleSelector).length > 0) {
            $(titleSelector).not("[data-truncate='none']").truncate({
                lines: 3,
                addClass: 'min-height',
            });
            $(loaSelector).not("[data-truncate='none']").truncate({
                lines: 1,
                type: 'list',
                addClass: 'loa-height',
            });
        }
    });
    if ($('.teaser__title').length > 0) {
        $(window).on('resized orientationchange', function () {
            $('.teaser__title, .teaser .loa').not("[data-truncate='none']").truncate();
        });
    }
})();
